module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Mouse-d8980dcd5b088b761854da3ece03b15b.svg";